var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCautionRed = function SvgCautionRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FE646F",
    fillRule: "evenodd",
    d: "M17.718 3.455 1.822 29.645c-1.306 2.151-1.306 4.751 0 6.903C3.13 38.703 5.497 40 8.11 40h31.784c2.613 0 4.977-1.297 6.284-3.452 1.307-2.152 1.307-4.752 0-6.904L30.286 3.455C28.98 1.3 26.616 0 24.002 0s-4.978 1.3-6.284 3.455",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD4755",
    fillRule: "evenodd",
    d: "M24.97.06a8 8 0 0 0-.968-.06c-2.613 0-4.978 1.3-6.284 3.455L1.822 29.645c-1.306 2.151-1.306 4.751 0 6.903C3.13 38.703 5.497 40 8.11 40h1.938c-2.614 0-4.982-1.297-6.288-3.452-1.307-2.152-1.307-4.752 0-6.904L19.655 3.455C20.798 1.57 22.75.34 24.971.06",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF5",
    fillRule: "evenodd",
    d: "M20.993 5.253 5.098 31.443a3.13 3.13 0 0 0 0 3.306c.633 1.038 1.747 1.653 3.01 1.653h31.784c1.26 0 2.378-.615 3.008-1.653a3.13 3.13 0 0 0 0-3.307L27.01 5.253C26.379 4.212 25.26 3.6 24 3.6c-1.264 0-2.378.612-3.008 1.653",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5AFC3",
    fillRule: "evenodd",
    d: "M37.955 36.402h1.938c1.26 0 2.377-.615 3.007-1.653a3.13 3.13 0 0 0 0-3.307L27.01 5.253C26.379 4.212 25.26 3.6 24 3.6q-.505 0-.97.126c.852.23 1.577.762 2.04 1.527l15.892 26.19a3.13 3.13 0 0 1 0 3.306c-.63 1.038-1.748 1.653-3.008 1.653",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE646F",
    fillRule: "evenodd",
    d: "M24.005 25.685c.956 0 1.737-.718 1.771-1.628l.452-11.812a1.6 1.6 0 0 0-.497-1.234 1.76 1.76 0 0 0-1.278-.516h-.895c-.5 0-.933.173-1.278.516a1.58 1.58 0 0 0-.497 1.234l.448 11.812c.034.91.819 1.628 1.774 1.628M24.004 32.269c-1.251 0-2.271-.971-2.271-2.162s1.02-2.16 2.27-2.16c1.252 0 2.272.97 2.272 2.16s-1.02 2.162-2.271 2.162",
    clipRule: "evenodd"
  })));
};
export default SvgCautionRed;